import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { finalize, Observable } from 'rxjs';
import { HelperServiceService } from '../../../utils/helper-service.service';
import { ToasterService } from '../../../providers/toaster/toaster.service';
import { Store } from '@ngrx/store';
import { format } from 'date-fns';
import { LoaderComponent } from '../../../providers/loader.component';
import { CommonModule } from '@angular/common';
import { CommonStaffApiServiceService } from '../../../pages/personnel/common-staff-api-service.service';
import { alphaNamePattern, alphaNumTextPattern, emailPattern, phonePattern, pincodePattern, strongPasswordPattern } from '../../../providers/regexPattern';
import { CascadingSelectServiceService } from '../../../pages/services/cascading-select-service.service';

@Component({
  selector: 'app-staff-common-form-modal',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './staff-common-form-modal.component.html',
  styleUrl: './staff-common-form-modal.component.css'
})
export class StaffCommonFormModalComponent {
  @ViewChild('modal') modal!: ElementRef<HTMLDialogElement>;

  


  // private trimNameValidator() {
  //   return (control: AbstractControl): ValidationErrors | null => {
  //     const value = control.value;
  //     if (value === null || value === undefined) {
  //       return null;
  //     }

  //     const str = value.toString();
  //     const trimmed = str.trim();
  //     // If user added leading/trailing spaces, mark invalid.
  //     // Otherwise keep it valid.
  //     return trimmed.length === 0 ? { required: true } : (str !== trimmed ? { trim: true } : null);
  //   };
  // }

  trimNameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      // Allow empty value
      if (!value) {
        return null;
      }

      if (value.trim() !== value || value.includes('  ')) {
        return { trim: true };
      }

      return null;
    };
  }

  // Used by Address error UI: "Address cannot contain only spaces."
  noOnlySpacesValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value === null || value === undefined) return null;
      if (typeof value !== 'string') return null;

      // If user typed only spaces (or empty after trim), mark as invalid
      return value.trim().length === 0 && value.length > 0 ? { noSpaces: true } : null;
    };
  }

  // Used by Email field: "Email must not contain spaces."
  noSpacesAnywhereValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value === null || value === undefined || value === '') return null;
      if (typeof value !== 'string') return null;

      return /\s/.test(value) ? { noSpaces: true } : null;
    };
  }


  @Input() userId: any = null;
  @Input() userType: 'HOD' | 'TEACHER' | 'STAFF' | null = null;
  @Input() isOpen: boolean = false;
  @Output() closeModalemmit = new EventEmitter();

  profile_pic: any = null;
  profilePicError: string | null = null;
  currentTab = 'personal';
  tabs = [
    { name: 'Personal Details', value: 'personal', isLock: false },
    { name: 'Address Details', value: 'address', isLock: true },
    { name: 'Education', value: 'education', isLock: true },
    { name: 'Work Experience', value: 'experience', isLock: true },
  ]

  type: 'new' | 'edit' = 'new';

  userDetails: any = {};
  departments$!: Observable<any>;


  userPersonalDetailsForm!: FormGroup
  userAddressDetailsForm!: FormGroup
  userEdcuationForm!: FormGroup
  userWorkExperienceForm!: FormGroup
  userAssignCourseForm!: FormGroup

  isreqSending: boolean = false
  isFetching: boolean = true
  showPassword: boolean = false;
  academicEntities$!: Observable<any>;
  years: number[] = [];

  departmentLists: any[] = []
  courses$!: Observable<any>;
  optionsMap: { classes: any[]; batches: any[] }[] = [];
  readonly todayDate = format(new Date(), 'yyyy-MM-dd');


  constructor(private fb: FormBuilder, private helperService: HelperServiceService, private toasterService: ToasterService
    , private staffApiService: CommonStaffApiServiceService, private cascadeService: CascadingSelectServiceService
  ) {
    this.academicEntities$ = this.cascadeService.academicEntries$
    this.academicEntities$.subscribe((data: any) => {
      this.departmentLists = data.data || [];
      this.syncAssignCourseOptions();
    })
    this.courses$ = this.cascadeService.course$
  }

  ngOnInit() {
    this.makeYear();
    this.departments$ = this.cascadeService.departments$

    this.userPersonalDetailsForm = this.fb.group({
      id: [null],
      first_name: ['', [
        Validators.required,
        // Trim extra spaces before validating at UI level
        this.trimNameValidator(),

        Validators.minLength(2),
        Validators.maxLength(50),
        // only alphabets and spaces
        Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)
      ]],
      last_name: ['', [
        Validators.required,
        this.trimNameValidator(),
        Validators.minLength(2),
        Validators.maxLength(50),
        Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)
      ]],
      email_id: ['', [
        Validators.required,
        Validators.pattern(emailPattern),
        Validators.maxLength(100),
        // Email must not contain any spaces
        this.noSpacesAnywhereValidator()
      ]],
      mobile: ['', [
        Validators.required,
        // Exactly 10 digits, numbers only
        Validators.pattern(/^\d{10}$/)
      ]],
      date_of_birth: ['', [Validators.required, this.pastDateValidator]],
      profile_photo: [null],
      department_id: [''],
     

      education: ['', [
        
        Validators.minLength(2),
        Validators.maxLength(100),
        this.trimNameValidator(),
        Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)
      ]],

      specialization: ['', [
       
        Validators.minLength(2),
        Validators.maxLength(100),
        this.trimNameValidator(),
        Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)
      ]],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(20),
        Validators.pattern(strongPasswordPattern),
        this.noSpacesAnywhereValidator()
      ]],
    })

    this.userAddressDetailsForm = this.fb.group({
      sameAsCurrent: [false],
      addresses: this.fb.array([
        this.fb.group({
          user_id: [this.userId],
          address_type: ['current'],
          address: ['', [
            Validators.required,
            Validators.minLength(5),
            Validators.maxLength(255),
            // trim leading/trailing spaces => invalid if not trimmed
            this.trimNameValidator(),
            // cannot contain only spaces
            this.noOnlySpacesValidator(),
          
            Validators.pattern(/^[A-Za-z0-9\s,\.\-/#]+$/)
          ]],
          city: ['', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(50),
            // trim leading/trailing spaces => invalid if not trimmed
            this.trimNameValidator(),
            Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)
          ]],
          district: ['', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(50),
            // trim leading/trailing spaces => invalid if not trimmed
            this.trimNameValidator(),
            // disallow only spaces
           
            // only alphabets and spaces (no numbers/special chars)
            Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)
          ]],
          state: ['', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(50),
            // trim leading/trailing spaces => invalid if not trimmed
            this.trimNameValidator(),
            // disallow only spaces
           
            // only alphabets and spaces (no numbers/special chars)
            Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)
          ]],
          pincode: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
          country: ['', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(50),
            // trim leading/trailing spaces => invalid if not trimmed
            this.trimNameValidator(),
            // disallow only spaces
           
            // only alphabets and spaces (no numbers/special chars)
            Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)
          ]],
        }),
        this.fb.group({
          user_id: [this.userId],
          address_type: ['permanent'],
          address: ['', [
            Validators.required,
            Validators.minLength(5),
            Validators.maxLength(255),
            // trim leading/trailing spaces => invalid if not trimmed
            this.trimNameValidator(),
            // disallow only spaces
           
            // allow alphabets, numbers, spaces and special chars: , . - / #
            Validators.pattern(/^[A-Za-z0-9\s,\.\-/#]+$/)
          ]],
          city: ['', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(50),
            // trim leading/trailing spaces => invalid if not trimmed
            this.trimNameValidator(),
            // disallow only spaces
           
            // only alphabets and spaces (no numbers/special chars)
            Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)
          ]],
          district: ['', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(50),
            // trim leading/trailing spaces => invalid if not trimmed
            this.trimNameValidator(),
            // disallow only spaces
           
            // only alphabets and spaces (no numbers/special chars)
            Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)
          ]],
          state: ['', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(50),
            // trim leading/trailing spaces => invalid if not trimmed
            this.trimNameValidator(),
            // disallow only spaces
           
            // only alphabets and spaces (no numbers/special chars)
            Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)
          ]],
          pincode: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
          country: ['', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(50),
            // trim leading/trailing spaces => invalid if not trimmed
            this.trimNameValidator(),
            // disallow only spaces
           
            // only alphabets and spaces (no numbers/special chars)
            Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)
          ]],
        })
      ]),
    });


    this.userAddressDetailsForm.get('sameAsCurrent')?.valueChanges.subscribe(checked => {
      this.onSameAsCurrentChange(checked);
    });

    this.userEdcuationForm = this.fb.group({
      educations: this.fb.array([
        this.createEducationGroup('graduation'),
        this.createEducationGroup('post-graduation')
      ])
    })

    this.userWorkExperienceForm = this.fb.group({
      work_experience: this.fb.array([
        this.fb.group({
          user_id: [this.userId],
          institute: ['', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(150),
            this.trimNameValidator(),
           
            Validators.pattern(/^[A-Za-z0-9.,\s\-&]+$/)
          ]],
          position: ['', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(100),
            this.trimNameValidator(),
           
            Validators.pattern(/^[A-Za-z0-9\s\-\/&]+$/)
          ]],
          duration: ['', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(30)
          ]],
        })
      ])
    })

    this.userAssignCourseForm = this.fb.group({
      assign_courses: this.fb.array([
        this.fb.group({
          user_id: [this.userId],
          course: ['', Validators.required],
          department: ['', Validators.required],
          class: ['', Validators.required],
          batch: ['', Validators.required],
          optionMap: this.fb.group({
            classes: [[]],
            batches: [[]]
          })
        })
      ])
    })

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen'] && changes['isOpen'].currentValue) {
      this.type = this.userId ? 'edit' : 'new';
      const hasAssignTab = this.tabs.some(tab => tab.value === 'assign-course');
      if (this.userType == 'TEACHER' && !hasAssignTab) {
        this.tabs.push({ name: 'Assign Course', value: 'assign-course', isLock: true });
      }
      if (this.userType !== 'TEACHER' && hasAssignTab) {
        this.tabs = this.tabs.filter(tab => tab.value !== 'assign-course');
      }
      if (this.userId && this.type === 'edit') {
        this.getUserData(this.userId);
        this.tabs.forEach((tab) => {
          tab.isLock = false;
        })
      } else {
        this.isFetching = false
      }
      console.log(this.type, this.userId);
      setTimeout(() => {
        this.modal?.nativeElement?.showModal();
      });
    }
  }


  get addressArray(): FormArray {
    return this.userAddressDetailsForm.get('addresses') as FormArray;
  }

  get currentAddress(): FormGroup {
    return this.addressArray.at(0) as FormGroup;
  }

  get permanentAddress(): FormGroup {
    return this.addressArray.at(1) as FormGroup;
  }

  get educationArray(): FormArray {
    return this.userEdcuationForm.get('educations') as FormArray;
  }

  get educationControls(): FormGroup[] {
    return this.educationArray.controls as FormGroup[];
  }

  get workExperienceArray(): FormArray {
    return this.userWorkExperienceForm.get('work_experience') as FormArray;
  }

  get workExperienceControls(): FormGroup[] {
    return this.workExperienceArray.controls as FormGroup[];
  }

  get assignCourseArray(): FormArray {
    return this.userAssignCourseForm.get('assign_courses') as FormArray;
  }

  get assignCourseControls(): FormGroup[] {
    return this.assignCourseArray.controls as FormGroup[];
  }

  private syncAssignCourseOptions() {
    if (!this.userAssignCourseForm) {
      return;
    }

    const formArray = this.userAssignCourseForm.get('assign_courses') as FormArray;
    if (!formArray) {
      return;
    }

    formArray.controls.forEach((control: any) => {
      const deptId = +control.get('department')?.value;
      const classId = +control.get('class')?.value;
      const dept = this.departmentLists.find((d: any) => d.id === deptId);
      const classes = dept?.classes || [];
      const selectedClass = classes.find((c: any) => c.id === classId);
      const batches = selectedClass?.batches || [];

      control.patchValue({
        optionMap: {
          classes,
          batches
        }
      }, { emitEvent: false });
    });
  }


  get isDataReady(): boolean {
    return !this.isFetching;
  }

  onSameAsCurrentChange(checked: boolean) {
    const current = this.currentAddress as FormGroup;
    const permanent = this.permanentAddress as FormGroup;

    if (checked) {
      // Copy current -> permanent, but keep user_id stable
      permanent.patchValue({ ...current.value, address_type: 'permanent', user_id: this.userId });
      permanent.disable();
    } else {
      // Ensure user_id is not lost after re-enabling/permanent reset
      permanent.enable();
      permanent.reset({
        user_id: this.userId,
        address_type: 'permanent'
      });
    }

  }

  getUserData(id: number) {
    if (!id) {
      this.toasterService.setToaster('error', 'Failed to Fatch Data', 'UserId Not Found');
      return;
    }
    this.staffApiService.getStaffProfile(id).subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.userDetails = res.data;
          this.patchValue(this.userDetails);
        }
      },
      error: (err) => {
        console.error('HTTP error:', err);
      }
    })
  }


  patchValue(data: any) {

    this.userPersonalDetailsForm.patchValue({
      id: data?.id,
      first_name: data?.first_name,
      last_name: data?.last_name,
      email_id: data?.email,
      mobile: data?.mobile,
      date_of_birth: data?.date_of_birth ? format(new Date(data.date_of_birth), 'yyyy-MM-dd') : null,
      profile_photo: null,
      department_id: data?.department_id,
      class_id: data?.admission_detail?.class_id,
      batch_id: data?.admission_detail?.batch_id,
      academic_year: data?.admission_detail?.academic_year,
      education: data?.education_text,
      specialization: data?.specialization,
    })

    this.userPersonalDetailsForm.removeControl('password');
    this.profile_pic = data?.profile_photo || data?.image || null;


    if (data?.address) {
      this.userAddressDetailsForm.patchValue({
        sameAsCurrent: false,
        addresses: [
          { ...data?.address[0], address_type: 'current' },
          { ...data?.address[1], address_type: 'permanent' },
        ]
      })
    }

    if (data?.education) {
      const educationFormArray = this.educationArray as FormArray;

      data.education.forEach((edu: any) => {
        const form = this.createEducationGroup(edu.education_type || 'other', {
          degree: edu.degree,
          year_of_degree: edu.year_of_degree,
          institute_name: edu.institute,
        });

        if (edu.education_type === 'graduation') {
          if (educationFormArray.at(0)) {
            educationFormArray.at(0).patchValue(form.value);
          } else {
            educationFormArray.insert(0, form);
          }
        } else if (edu.education_type === 'post-graduation') {
          if (educationFormArray.at(1)) {
            educationFormArray.at(1).patchValue(form.value);
          } else {
            educationFormArray.insert(1, form);
          }
        } else {
          form.patchValue({ education_type: 'other' });
          educationFormArray.push(form);
        }
      });
    }

    if (data?.experience && data.experience.length > 0) {
      const workExperienceFormArray = this.workExperienceArray as FormArray;
      workExperienceFormArray.clear();
      data.experience.forEach((exp: any) => {
        const form = this.fb.group({
          user_id: [this.userId],
          institute: [exp.institute, [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(150),
            this.trimNameValidator(),
           
            Validators.pattern(/^[A-Za-z0-9.,\s\-&]+$/)
          ]],
          position: [exp.position, [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(100),
            this.trimNameValidator(),
           
            Validators.pattern(/^[A-Za-z0-9\s\-\/&]+$/)
          ]],
          duration: [exp.duration, [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(30)
          ]],
        });
        workExperienceFormArray.push(form);
      });
    }

    if (data?.assigned_courses && this.userType === 'TEACHER') {
      const assignCourseFormArray = this.assignCourseArray as FormArray;
      assignCourseFormArray.clear();
      data.assigned_courses.forEach((course: any) => {
        const dept = this.departmentLists.find((d: any) => d.id === course.department_id);
        const classes = dept?.classes || [];
        const selectedClass = classes.find((c: any) => c.id === course.class_id);
        const batches = selectedClass?.batches || [];

        const form = this.fb.group({
          id: [course.id || ""],
          user_id: [this.userId],
          course: [course.course_id, Validators.required],
          department: [course.department_id, Validators.required],
          class: [course.class_id, Validators.required],
          batch: [course.batch_id, Validators.required],
          optionMap: this.fb.group({
            classes: [classes],
            batches: [batches]
          })
        });
        assignCourseFormArray.push(form);
      });
    }



    this.isFetching = false

  }
  // *************************




  modifyEducation(action: 'add' | 'remove', index?: number): void {
    if (action === 'add') {
      this.educationArray.push(this.createEducationGroup('other'));
    } else if (action === 'remove' && index !== undefined && this.educationArray.length > 1) {
      this.educationArray.removeAt(index);
    }
  }

  modifyExperience(action: 'add' | 'remove', index?: number): void {
    if (action === 'add') {
      const form = this.fb.group({
        user_id: [this.userId],
        institute: ['', [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(150),
          this.trimNameValidator(),
         
          Validators.pattern(/^[A-Za-z0-9.,\s\-&]+$/)
        ]],
        position: ['', [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(100),
          this.trimNameValidator(),
         
          Validators.pattern(/^[A-Za-z0-9\s\-\/&]+$/)
        ]],
        duration: ['', [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(30)
        ]],
      })
      this.workExperienceArray.push(form);
    } else if (action === 'remove' && index !== undefined && this.workExperienceArray.length > 1) {
      this.workExperienceArray.removeAt(index);
    }
  }

  modifyAssignCourse(action: 'add' | 'remove', index?: number): void {
    if (action === 'add') {
      const form = this.fb.group({
        user_id: [this.userId],
        course: ['', Validators.required],
        department: ['', Validators.required],
        class: ['', Validators.required],
        batch: ['', Validators.required],
        optionMap: this.fb.group({
          classes: [[]],
          batches: [[]]
        })
      })
      this.assignCourseArray.push(form);
    } else if (action === 'remove' && index !== undefined && this.assignCourseArray.length > 1) {
      this.assignCourseArray.removeAt(index);
    }
  }
  saveUserDetails() {
    if (this.userPersonalDetailsForm.invalid) {
      this.userPersonalDetailsForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Validation Error', 'Please fix highlighted fields in Personal Details.');
      return;
    }
    if (this.isInvalidDob(this.userPersonalDetailsForm.value.date_of_birth)) {
      this.toasterService.setToaster('error', 'Validation Error', 'Date of birth must be a valid past date.');
      return;
    }
    let role_id = 0;
    switch (this.userType) {
      case 'HOD':
        role_id = 6;
        break;
      case 'TEACHER':
        role_id = 7;
        break;
      case 'STAFF':
        role_id = 10;
        break;
    }
    const formData = new FormData();
    formData.append('first_name', this.userPersonalDetailsForm.value.first_name);
    formData.append('last_name', this.userPersonalDetailsForm.value.last_name);
    formData.append('email_id', this.userPersonalDetailsForm.value.email_id);
    formData.append('mobile_no', this.userPersonalDetailsForm.value.mobile);
    formData.append('date_of_birth', this.userPersonalDetailsForm.value.date_of_birth);
    if (this.userPersonalDetailsForm.value.profile_photo) {
      formData.append('profile_photo', this.userPersonalDetailsForm.value.profile_photo);
    }
    formData.append('department_id', this.userPersonalDetailsForm.value.department_id);
    formData.append('education', this.userPersonalDetailsForm.value.education);
    formData.append('specialization', this.userPersonalDetailsForm.value.specialization);
    formData.append('role_id', role_id.toString());
    if (this.type == 'new') {
      formData.append('password', this.userPersonalDetailsForm.value.password);
    }

    if (!role_id) {
      this.toasterService.setToaster('error', 'Error', 'Role is not selected.');
      return
    }


    this.isreqSending = true;

    if (this.type === 'edit' && this.userId) {
      this.staffApiService.updateStaffProfile(formData, this.userId).pipe(
        finalize(() => {
          this.isreqSending = false;
        })).subscribe({
          next: (res: any) => {
            if (res.status === 'success') {
              this.toasterService.setToaster('success', 'Success', res.message ?? 'User updated successfully');
            } else {
              this.toasterService.setToaster('error', 'Failed', res.message ?? 'Something went wrong');
            }
          },
          error: (err) => {
            this.toasterService.setToaster('error', 'Failed', this.readHttpError(err, 'Unable to update details'));
          }
        }
        )
    } else {
      this.staffApiService.createStaffProfile(formData).pipe(
        finalize(() => {
          this.isreqSending = false;
        })).subscribe({
          next: (res: any) => {
            if (res.status === 'success') {
              this.toasterService.setToaster('success', 'Success', res.message ?? 'User Added successfully');
              this.type = 'edit';
              this.userId = res.data.user_id;
              this.tabs[1].isLock = false;
              this.tabs[2].isLock = false;
              this.tabs[3].isLock = false;
              if (this.userType == 'TEACHER') {
                this.tabs[4].isLock = false;
              }

              this.workExperienceControls.forEach((control) => {
                control.patchValue({ user_id: this.userId });
              });

              this.educationControls.forEach((control) => {
                control.patchValue({ user_id: this.userId });
              });
              this.addressArray.controls.forEach((control) => {
                control.patchValue({ user_id: this.userId });
              });
              this.assignCourseControls.forEach((control) => {
                control.patchValue({ user_id: this.userId });
              });

            } else {
              this.toasterService.setToaster('error', 'Failed', res.message ?? 'Something went wrong');
            }
          },
          error: (err) => {
            this.toasterService.setToaster('error', 'Failed', this.readHttpError(err, 'Unable to create user'));
          }
        }
        )
    }

  }

  saveUserAddressDetails() {
    if (this.userAddressDetailsForm.invalid) {
      this.userAddressDetailsForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Validation Error', 'Please fix highlighted fields in Address Details.');
      return;
    }

    const addressValue = this.userAddressDetailsForm.getRawValue();
    let data = addressValue.addresses;
    data = data.map((address: any) => ({ ...address, pincode: address.pincode.toString() }));
    this.isreqSending = true;
    this.staffApiService.setStaffAddress(data).pipe(
      finalize(() => {
        this.isreqSending = false;
      }))
      .subscribe({
        next: (res: any) => {
          if (res.status === 'success') {
            this.toasterService.setToaster('success', 'Success', res.message ?? 'Address details updated successfully');
          }
        },
        error: (err) => {
          this.toasterService.setToaster('error', 'Failed', this.readHttpError(err, 'Unable to save address details'));
        }
      });

  }

  saveUserEducationDetails() {
    this.educationControls.forEach((control) => this.updateOptionalEducationValidators(control));

    if (this.userEdcuationForm.invalid) {
      this.userEdcuationForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Validation Error', 'Please fix highlighted fields in Education Details.');
      return;
    }
    this.isreqSending = true;
    const data = this.educationArray.getRawValue().filter((education: any) => {
      return this.isRequiredEducationType(education.education_type) || this.hasEducationDetails(education);
    });
    this.staffApiService.setStaffEducation(data).pipe(
      finalize(() => {
        this.isreqSending = false;
      }))
      .subscribe({
        next: (res: any) => {
          if (res.status === 'success') {
            this.toasterService.setToaster('success', 'Success', res.message ?? 'Education details updated successfully');
          }
        },
        error: (err) => {
          this.toasterService.setToaster('error', 'Failed', this.readHttpError(err, 'Unable to save education details'));
        }
      });
  }

  saveWorkExperienceDetails() {
    if (this.userWorkExperienceForm.invalid) {
      this.userWorkExperienceForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Validation Error', 'Please fix highlighted fields in Work Experience.');
      return;
    }
    this.isreqSending = true;
    const data = this.userWorkExperienceForm.get('work_experience')?.value;
    this.staffApiService.setStaffExperience(data).pipe(
      finalize(() => {
        this.isreqSending = false;
      }))
      .subscribe({
        next: (res: any) => {
          if (res.status === 'success') {
            this.toasterService.setToaster('success', 'Success', res.message ?? 'Work Experience details updated successfully');
          }
        },
        error: (err) => {
          this.toasterService.setToaster('error', 'Failed', this.readHttpError(err, 'Unable to save work experience'));
        }
      });
  }

  saveAssignCourse() {
    if (this.userAssignCourseForm.invalid) {
      this.userAssignCourseForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Validation Error', 'Please fill all required fields in Assign Course.');
      return;
    }

    this.isreqSending = true;
    const rawData = this.userAssignCourseForm.getRawValue();
    console.log(rawData);
    const data = rawData.assign_courses.map((course: any) => ({
      id: course.id || "",
      user_id: this.userId,
      course_id: Number(course.course),
      department_id: course.department,
      class_id: course.class,
      batch_id: course.batch
    }));

    this.staffApiService.setStaffAssignCourse(data).pipe(
      finalize(() => {
        this.isreqSending = false;
      }))
      .subscribe({
        next: (res: any) => {
          if (res.status === 'success') {
            this.toasterService.setToaster('success', 'Success', res.message ?? 'Assign Course details updated successfully');
          }
        },
        error: (err) => {
          this.toasterService.setToaster('error', 'Failed', this.readHttpError(err, 'Unable to assign course'));
        }
      });
  }

  onAssignCourseSelectChange(
    event: Event,
    index: number,
    type: 'department' | 'class'
  ) {
    const selectedValue = +(event.target as HTMLSelectElement).value;

    const formArray = this.userAssignCourseForm.get('assign_courses') as FormArray;
    const row = formArray.at(index) as FormGroup;

    if (type === 'department') {
      // Find selected department
      const dept = this.departmentLists.find((d: any) => d.id === selectedValue);

      // Update optionMap with classes
      row.patchValue({
        class: '',
        batch: '',
        optionMap: {
          classes: dept?.classes || [],
          batches: []
        }
      });
    }

    if (type === 'class') {
      // Find the department of the selected row first
      const deptId = +row.get('department')?.value;
      const dept = this.departmentLists.find(d => d.id === deptId);

      // Find selected class inside that department
      const cls = dept?.classes.find((c: any) => c.id === selectedValue);

      // Update optionMap with batches
      row.patchValue({
        batch: '',
        optionMap: {
          classes: row.value.optionMap.classes,
          batches: cls?.batches || []
        }
      });
    }

    console.log(row.value);

  }

  getAssignCourseOptions(index: number, type: 'class' | 'batch') {
    const formArray = this.userAssignCourseForm.get('assign_courses') as FormArray;
    const optionMap = formArray.at(index).get('optionMap')?.value || {};

    if (type === 'class') {
      return optionMap.classes || [];
    }

    if (type === 'batch') {
      const selectedClassId = formArray.at(index).get('class')?.value;
      const selectedClass = (optionMap.classes || []).find((cls: any) => cls.id == selectedClassId);
      return selectedClass ? selectedClass.batches || [] : [];
    }

    return [];
  }





  // ************************* 
  async setProfilePic(event: any) {
    const input = event.target as HTMLInputElement;
    const { image, imageUrl } = this.helperService.getImageFileAndUrl(event);

    if (!image) {
      this.profilePicError = null;
      this.userPersonalDetailsForm.patchValue({ profile_photo: null });
      this.profile_pic = null;
      return;
    }

    const validationError = await this.validateProfileImage(image);
    if (validationError) {
      this.profilePicError = validationError;
      this.userPersonalDetailsForm.patchValue({ profile_photo: null });
      this.profile_pic = null;
      if (input) {
        input.value = '';
      }
      return;
    }

    this.profilePicError = null;
    this.userPersonalDetailsForm.patchValue({ profile_photo: image });
    this.profile_pic = imageUrl;
  }

  private validateProfileImage(file: File): Promise<string | null> {
    return new Promise((resolve) => {
      const fileName = file.name.toLowerCase();
      const isSupportedExtension = /\.(jpe?g|png)$/i.test(fileName);
      const isSupportedMimeType = ['image/jpeg', 'image/png'].includes(file.type.toLowerCase());

      if (!isSupportedExtension || !isSupportedMimeType) {
        resolve('Only .jpg, .jpeg, and .png files are allowed.');
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        resolve('Profile image must be 2 MB or smaller.');
        return;
      }

      resolve(null);
    });
  }

  closeModal() {
    this.modal?.nativeElement?.close();
    this.profile_pic = null;
    this.profilePicError = null;
    this.userId = null;
    this.isOpen = false;
    this.currentTab = 'personal';
    this.tabs.forEach((tab) => {
      tab.isLock = true;
    })
    this.tabs[0].isLock = false;
    this.userPersonalDetailsForm.reset();
    this.userAddressDetailsForm.reset();
    this.userEdcuationForm.reset();
    this.userWorkExperienceForm.reset();
    this.userAssignCourseForm.reset();

    this.emitData('close');
  }

  makeYear() {
    const today = new Date();
    const previous50Years = today.getFullYear() - 50;
    for (let year = today.getFullYear(); year >= previous50Years; year--) {
      this.years.push(year);
    }
  }

  emitData(action: string) {
    console.log('action', action);
    this.closeModalemmit.emit(action);
  }

  isInvalidDob(value: string): boolean {
    if (!value) {
      return true;
    }
    const selectedDate = new Date(value);
    const today = new Date();
    selectedDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return selectedDate >= today;
  }

  private pastDateValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) {
      return null;
    }
    const selectedDate = new Date(value);

    // Must be a valid calendar date
    if (isNaN(selectedDate.getTime())) {
      return { invalidDate: true };
    }

    const today = new Date();
    selectedDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return selectedDate >= today ? { pastDate: true } : null;
  }

  readHttpError(err: any, fallback: string): string {
    return err?.error?.message || err?.error?.error || err?.message || fallback;
  }

  createEducationGroup(educationType: string = 'other', value: any = {}): FormGroup {
    const form = this.fb.group({
      user_id: [this.userId],
      education_type: [educationType],
      degree: [
        value.degree ?? '',
        this.getEducationValidators('degree', this.isRequiredEducationType(educationType))
      ],
      year_of_degree: [
        value.year_of_degree ?? '',
        this.getEducationValidators('year_of_degree', this.isRequiredEducationType(educationType))
      ],
      institute_name: [
        value.institute_name ?? '',
        this.getEducationValidators('institute_name', this.isRequiredEducationType(educationType))
      ],
    });

    if (!this.isRequiredEducationType(educationType)) {
      form.valueChanges.subscribe(() => this.updateOptionalEducationValidators(form));
      this.updateOptionalEducationValidators(form);
    }

    return form;
  }

  updateOptionalEducationValidators(control: AbstractControl): void {
    const form = control as FormGroup;
    const educationType = form.get('education_type')?.value;

    if (this.isRequiredEducationType(educationType)) {
      return;
    }

    const shouldRequireFields = this.hasEducationDetails(form.getRawValue());

    ['degree', 'year_of_degree', 'institute_name'].forEach((field) => {
      const fieldControl = form.get(field);
      if (!fieldControl) {
        return;
      }

      fieldControl.setValidators(this.getEducationValidators(field, shouldRequireFields));
      fieldControl.updateValueAndValidity({ emitEvent: false });
    });
  }

  isEducationFieldRequired(education: AbstractControl): boolean {
    const value = (education as FormGroup).getRawValue();
    return this.isRequiredEducationType(value.education_type) || this.hasEducationDetails(value);
  }

  private getEducationValidators(field: string, required: boolean) {
    const validators = [];

    if (required) {
      validators.push(Validators.required);
    }

    if (field === 'degree') {
      validators.push(
        Validators.minLength(2),
        Validators.maxLength(100),
        this.trimNameValidator(),
       
        // allow: letters, numbers, spaces, period, hyphen, ampersand
        Validators.pattern(/^[A-Za-z0-9.\s\-&]+$/)
      );
    } else if (field === 'institute_name') {
      validators.push(
        Validators.minLength(2),
        Validators.maxLength(150),
        this.trimNameValidator(),
       
        // allow: letters, numbers, spaces, period, comma, hyphen, ampersand
        Validators.pattern(/^[A-Za-z0-9.,\s\-&]+$/)
      );
    }

    return validators;
  }

  private isRequiredEducationType(educationType: string): boolean {
    return educationType === 'other';
  }

  private hasEducationDetails(education: any): boolean {
    return ['degree', 'year_of_degree', 'institute_name'].some((field) => {
      const value = education?.[field];
      return value !== null && value !== undefined && value.toString().trim() !== '';
    });
  }
}